import isInViewport from '../utils/inViewport';

export default class SoftwareKeyComponents {
  constructor() {
    this.selector = '.b-software-key-components';

    this.selectors = {
      toggle: '.b-software-key-components__toggle-button',
      tab: '.b-software-key-components__col-tab',
    };
  }

  bootstrap() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      const toggles = block.querySelectorAll(this.selectors.toggle);
      const tabs = block.querySelectorAll(this.selectors.tab);

      toggles.forEach(toggle => {
        toggle.addEventListener('click', event => {
          tabs.forEach(tab => {
            tab.classList.remove('d-none');
            if (tab.dataset.tabContent !== event.target.dataset.tab) {
              tab.classList.add('d-none');
            }
          });
        });
      });
    });

    window.addEventListener('scroll', this.handleBlocksOnScroll.bind(this));
  }

  handleBlocksOnScroll() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    blocks.forEach(block => {
      if (isInViewport(block)) {
        block.classList.add('in-viewport');
      }
    });
  }
}
